module.exports = __webpack_public_path__ + "static/img/smj_intro_pic.1b6c5952.jpg";